var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"absolute full right-0"},[_c('IconExtraOptions',{staticClass:"text-gray-500 hover:text-primary h-6 pt-0-5"}),_c('div',{staticClass:"absolute w-full bg-red-500 w-24 left-0"},[_vm._v("\r\n        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laboriosam, nesciunt.\r\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }